/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Event_Group_Retrieved_MessageInputs */



/**
* | output |
* | --- |
* | "Selected event group retrieved successfully" |
*
* @param {Iframe_Remote_Event_Group_Retrieved_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_event_group_retrieved_message = /** @type {((inputs?: Iframe_Remote_Event_Group_Retrieved_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Event_Group_Retrieved_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe d'evenements selectionne recupere avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählte Ereignisgruppe erfolgreich abgerufen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo di eventi selezionato recuperato correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбранная группа событий успешно получена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El grupo de eventos seleccionado se recuperó correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已成功检索所选事件组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントグループが正常に取得されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित इवेंट समूह सफलतापूर्वक प्राप्त कर लिया गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de eventos selecionado recuperado com sucesso.")
	return /** @type {LocalizedString} */ ("Selected event group retrieved successfully")
});